"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_1 = __importDefault(require("../../styled"));
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
exports.ImageFit = {
    contain: 'contain',
    cover: 'cover',
    none: 'unset',
    'scale-down': 'scale-down'
};
var Image = function (props) { return (React.createElement(Image.Element, __assign({ src: props.src || props.source, alt: props.alt }, automation_attribute_1.default('image'), props))); };
Image.Element = styled_1.default.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  height: ", ";\n  width: ", ";\n  max-width: ", ";\n  object-fit: ", ";\n"], ["\n  display: block;\n  height: ", ";\n  width: ", ";\n  max-width: ", ";\n  object-fit: ", ";\n"])), function (props) { return (props.height ? props.height : 'auto'); }, function (props) { return (props.width ? props.width : 'auto'); }, function (props) { return (props.disableResponsive ? 'auto' : '100%'); }, function (props) { return exports.ImageFit[props.fit]; });
Image.defaultProps = {
    source: null,
    alt: null,
    width: null,
    height: null,
    fit: 'none'
};
exports.default = Image;
var templateObject_1;
//# sourceMappingURL=image.js.map